import { createContext, useContext } from "react";

/** Keeps server-side filters from being limited to values in the currently loaded page. */
type ExternalFacetValuesMap = Map<string, Map<string, number>>;

const ExternalFacetValuesContext = createContext<ExternalFacetValuesMap | null>(null);

export const ExternalFacetValuesProvider = ExternalFacetValuesContext.Provider;

export function useExternalFacetValues(columnId: string): Map<string, number> | null {
	const ctx = useContext(ExternalFacetValuesContext);
	return ctx?.get(columnId) ?? null;
}
